import React from 'react';

function TetanusVaccineForm() {
  return (
    <div>
      <h2>TetanusVaccineForm</h2>
    </div>
  );
}

export default TetanusVaccineForm;
